import { CoreTextView, TCoreTextData, TCoreTextOptions, type TCoreTextStyleProps } from '@core/widgets';
import { TCommonData, TWidget, TWidgetCommonOption } from '@libs/types';
import React from 'react';
import { TTextOption } from '../../types/options';

declare const VERSION: string;

const APP_VERSION_STYLE_KEY = 'appVersionText';

const DEFAULT_PLATFORM = 'Web';

const TEXT_ALIGN_MAP: Record<NonNullable<TTextOption['textAlign']>, NonNullable<TCoreTextStyleProps['textAlign']>> = {
    start: 'start',
    center: 'center',
    end: 'end',
    justified: 'justify',
};

type TAppVersionTextViewProps = {
    widget?: TWidget<TCommonData, TTextOption>;
    uid?: string;
    platform?: string;
    styleName?: string;
    textColor?: TTextOption['textColor'];
    textAlign?: TTextOption['textAlign'];
    maxLines?: TTextOption['maxLines'];
} & Pick<TWidgetCommonOption, 'margin' | 'isHide' | 'isDisabled'>;

const AppVersionTextView = ({
    uid,
    widget,
    platform = DEFAULT_PLATFORM,
    isHide,
    isDisabled,
    margin,
    styleName = APP_VERSION_STYLE_KEY,
    textColor = 'grey_72_lc',
    textAlign,
    maxLines,
}: TAppVersionTextViewProps) => {
    const fallbackColor = `var(--${textColor})`;
    const styleProps: TCoreTextStyleProps = {
        main: fallbackColor,
        disabled: { main: fallbackColor },
        fontStyle: { fontSize: 17 },
        textAlign: textAlign ? TEXT_ALIGN_MAP[textAlign] : 'start',
        maxLines,
        margin,
    };

    return (
        <CoreTextView
            widget={widget as TWidget<TCoreTextData, TCoreTextOptions>}
            uid={uid}
            text={`${platform} · ${VERSION}`}
            isHide={isHide}
            isDisabled={isDisabled}
            styleName={styleName}
            styleProps={styleProps}
        />
    );
};

export { AppVersionTextView };
